import React from 'react';
import './Focusskillbox.css';
import { Link } from 'react-router-dom';
import NoItemView from '../NoItemView';
import { GLOBAL_COLORS, IBLSpinLoader } from '@iblai/ibl-web-react-common';
import { FaPlus } from 'react-icons/fa6';
import { useTranslation } from 'react-i18next';

const Focusskillbox = ({ userSkillsData, userSkillsDataLoaded }) => {
  const { t } = useTranslation();
  // Filter out duplicate skills using a Set
  const uniqueSkills = Array.from(
    new Set(userSkillsData?.map((skill) => skill.name))
  ).map((name) => userSkillsData.find((skill) => skill.name === name));

  return (
    <div className="prof_box">
      <div className="div-block-15">
        <div className="text-block sec_title">{t('Latest Skills')}</div>
        <Link className="link-block-5 w-inline-block" to="/profile/skills">
          <FaPlus className="image-15" color={GLOBAL_COLORS.icon_color} />
        </Link>
      </div>
      <div>
        {!userSkillsDataLoaded ? (
          <IBLSpinLoader size={40} containerHeight={'100px'} />
        ) : uniqueSkills.length > 0 ? (
          uniqueSkills.slice(0, 5).map((skill, index) => (
            <div className="div-block-17 al_l" key={index}>
              <div className="div-block-16">
                <div className="text-block-12">{skill?.name}</div>
              </div>
            </div>
          ))
        ) : (
          userSkillsDataLoaded && (
            <NoItemView
              imageUrl={'images/skills_icon_1skills_icon.png'}
              displayMessage={t('No skills yet')+'.'}
            />
          )
        )}
      </div>

      <div className="div-block-18 hidden">
        <a
          className="link-block-4 w-inline-block"
          href="https://ibl-skills-v7.webflow.io/profile#skills"
        >
          <div className="text-block-13">{t('Manage Skills')}</div>
          <img
            alt=""
            className="image-15 rc"
            loading="lazy"
            src="images/chevron_1chevron.png"
          />
        </a>
        <a className="link-block-4 start w-inline-block" href="start.html">
          <div className="text-block-13">{t('Re-Evaluate')}</div>
          <img
            alt=""
            className="image-15 rc"
            loading="lazy"
            src="images/chevron_1chevron.png"
          />
        </a>
      </div>
    </div>
  );
};

export default Focusskillbox;
